import { BaseEntityClass } from "@shared/services/event_tracking/entities/base_entity_class";

interface CustomPriceEntityParams {
  location: string;
  price: number;
}
export class CustomPriceEntity extends BaseEntityClass {
  location: string;
  price: number;
  constructor(params: CustomPriceEntityParams) {
    super();
    this.type = "custom_price";
    this.entity_version = 2;
    this.location = params.location;
    this.price = params.price;
  }
}
